import { FC } from "react";
import { Box, Button, Container, Flex, Heading, Text, VStack } from "@chakra-ui/react";
import Link from "next/link";
import { LandingPageContent } from "@/constants/landingPages";

interface LandingCtaSectionProps {
  content: LandingPageContent["finalCta"];
  locale: string;
}

export const LandingCtaSection: FC<LandingCtaSectionProps> = ({ content, locale }) => (
  <Box py={{ base: "16", md: "24" }} bg="gray.900" color="white">
    <Container maxW="5xl">
      <VStack spacing="8" textAlign="center">
        <Heading as="h2" fontSize={{ base: "3xl", md: "4xl" }} maxW="800px">
          {content.title}
        </Heading>

        <Flex
          gap="4"
          direction={{ base: "column", md: "row" }}
          justify="center"
        >
          <Button
            as={Link}
            href={`/${locale}#kontakt`}
            size="lg"
            colorScheme="blue"
            px="8"
            py="6"
            fontSize="lg"
            fontWeight="600"
            boxShadow="lg"
            _hover={{
              transform: "translateY(-2px)",
              boxShadow: "xl",
            }}
            transition="all 0.3s"
          >
            {content.ctaPrimary}
          </Button>
          <Button
            as="a"
            href="#pricing"
            size="lg"
            variant="outline"
            colorScheme="whiteAlpha"
            px="8"
            py="6"
            fontSize="lg"
            fontWeight="600"
            _hover={{
              transform: "translateY(-2px)",
              bg: "whiteAlpha.200",
            }}
            transition="all 0.3s"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            {content.ctaSecondary}
          </Button>
        </Flex>

        <Text fontSize="sm" color="gray.400" pt="4">
          {content.footerNote}
        </Text>
      </VStack>
    </Container>
  </Box>
);
